import React, { useState, useMemo } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const CalculadoraEfectivoModal = ({
  show,
  onClose,
  total,
  maxPorcentaje = 10,
  maxPorcentajeRedondeo = 20, //variable con el 20 para q se adapte al redondeo y no sea tan riguroso
  onAplicar
}) => {
  const [totalDeseado, setTotalDeseado] = useState("");

  // Total con descuento máximo permitido (ej: 10%)
  const totalConMaxDescuento = useMemo(() => {
    return total * (1 - maxPorcentaje / 100);
  }, [total, maxPorcentaje]);

  // Porcentaje sugerido (3 decimales para evitar 17.999)
  const porcentajeSugerido = useMemo(() => {
    if (!totalDeseado || totalDeseado >= total) return 0;

    const descuento = total - Number(totalDeseado);
    return Number(((descuento / total) * 100).toFixed(5));
  }, [totalDeseado, total]);

  const montoDescuento = useMemo(() => {
    return total * (porcentajeSugerido / 100);
  }, [porcentajeSugerido, total]);

  const esValido =
    porcentajeSugerido >= 0 &&
    porcentajeSugerido <= maxPorcentajeRedondeo //&&
    // Number(totalDeseado) >= totalConMaxDescuento; quite esto para q no compare si es mayor o igual al total con maximo descuento q seria con el 10%aplicado

  const aplicar = () => {
    if (!esValido) return;
    onAplicar(porcentajeSugerido);
    setTotalDeseado("");
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Calculadora de efectivo</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-1">
          <strong>Total sin descuento:</strong> ${total.toFixed(2)}
        </p>

        <p className="mb-1 text-muted">
          <strong>Total con {maxPorcentaje}%:</strong>{" "}
          ${totalConMaxDescuento.toFixed(2)}
        </p>

        <Form.Group className="mt-3">
          <Form.Label>Total que quiero cobrar</Form.Label>
          <Form.Control
            type="number"
            value={totalDeseado}
            onChange={(e) => setTotalDeseado(e.target.value)}
            placeholder="Ej: 17600"
          />
        </Form.Group>

        <hr />

        <p className="mb-1">
          <strong>Descuento sugerido:</strong> ${montoDescuento.toFixed(2)}
        </p>
        <p className="mb-1">
          <strong>Porcentaje aplicado:</strong>{" "}
          {porcentajeSugerido.toFixed(3)}%
        </p>

        {!esValido && totalDeseado && (
          <Alert variant="danger" className="mt-2 p-2">
            El total ingresado supera el descuento máximo permitido (
            {maxPorcentajeRedondeo}%)
          </Alert>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="success"
          disabled={!esValido}
          onClick={aplicar}
        >
          Aplicar descuento
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CalculadoraEfectivoModal;
